import React from 'react';
import { Heading1, Heading3, Paragraph } from '../../components/typography';
import { Row, Col, Container } from '../../components/grid';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import TheVideoPlayer from '../../components/TheVideoPlayer';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="Video">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>
            Opsætning af stilladsbar
          </Heading1>
          <Paragraph>
            Opsætning af stilladsbar - med plads til 3 fadølshaner og fadølsanlæg - sådan opsættes baren.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <Row>
        <Col xs={12} padding="0">
          <TheVideoPlayer url="G3H9SymGqzg" thumbnail="stilladsbar" />
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3>
            Udskrift af video
          </Heading3>
          <Paragraph>
            En stilladsbar består af 6 dele. To gavle. To diagonal-stænger.
            En bordplade. Og et forstykke med reklame på.
          </Paragraph>
          <Paragraph>
            Der findes to forskellige typer forstykker. Nogle af dem sidder, som dette,
            på med velcro og nogen af dem sidder på med elastikker. I de her øjer.
          </Paragraph>
          <Paragraph>
            Så det er vigtigt at vende gavlene sådan så øjerne vender ud mod gæsterne.
            Der er et øje oppe og et øje nede. Bruger man et forstykke med elastik
            sættes de på sådan her.
          </Paragraph>
          <Paragraph>
            Stil gavlene op med øjerne ud mod gæsterne. Sørg for at diagonal-stængerne
            er åbne. Sæt dem ikke helt ud til kanten da der skal være plads til
            bordpladen. Så skal bordpladen på. Hvis forstykket er med velcro skal
            bordpladen vende med velcroen ud af. Sæt herefter forstykket med reklame
            på med velcroen. Så er stilladsbaren klar med plads til fadølsanlæg og
            ihvertfald tre fadølshaner.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
